export const FUEL_TYPES = [
  { key: 'premium', label: 'premiumGasoline' },
  { key: 'regular', label: 'regularGasoline' },
  { key: 'diesel', label: 'diesel' },
  { key: 'kerosene', label: 'kerosene' },
];

export type FUEL_TYPE = 'premium' | 'regular' | 'diesel' | 'kerosene';
